import React from "react";

export const readExcelColumns=(type)=>{
  let timeTitle = "";
  switch(type){
    case 1:
      timeTitle = "阅读时间"
      break;
      case 2:
      timeTitle = "点赞时间"
      break;
      case 3:
      timeTitle = "下载时间"
      break;
      case 4:
        timeTitle = "收藏时间"
      break;
      default:
        break;
  }
  return [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
      },
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: {}
      },
    },
    {
      headerName: "任职",
      field: "userIdentityInfos",
      width: 100,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: timeTitle,
      field: 'createTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
  ];
} 


export const readUserIdentityExcelColumns =(type)=>{
  let timeTitle = "";
  switch(type){
    case 1:
      timeTitle = "首次阅读时间"
      break;
      case 2:
      timeTitle = "首次点赞时间"
      break;
      case 3:
      timeTitle = "首次下载时间"
      break;
      case 4:
      timeTitle = "首次收藏时间"
      break;
      default:
        break;
  }
  return [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
      },
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: {}
      },
    },
    {
      headerName: "组织名称",
      field: "orgPathName",
      width: 80,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "组织编码",
      field: "orgCode",
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "岗位",
      field: "positionName",
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: timeTitle,
      field: 'firstOperationTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
  ];
} 


export const commentExcelColumns=()=>{
  return [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
      },
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: {}
      },
    },
    {
      headerName: "任职",
      field: "userIdentityInfos",
      width: 100,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "评论时间",
      field: 'commentTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    // {
    //   headerName: "投诉次数",
    //   field: 'createTime',
    //   width: 20,
    //   cellStyle: {
    //     textAlign: 'left',
    //   },
    //   style: {
    //     alignment: { vertical: 'middle', horizontal: 'center' },
    //   },
    // },
    {
      headerName: "评论内容",
      field: 'content',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复人",
      field: 'replyFullName',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复时间",
      field: 'replyCommentTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复内容",
      field: 'replyContent',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "状态",
      field: 'stateStr',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
  ];
} 


export const commentUserIdentityExcelColumns =()=>{
  return [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
      },
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 15,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 15,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
        font: {}
      },
    },
    {
      headerName: "组织名称",
      field: "orgPathName",
      width: 80,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "组织编码",
      field: "orgCode",
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "岗位",
      field: "positionName",
      width: 30,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "评论时间",
      field: 'commentTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "评论内容",
      field: 'content',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复人",
      field: 'replyFullName',
      width: 15,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复时间",
      field: 'replyCommentTime',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "回复内容",
      field: 'replyContent',
      width: 20,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
    {
      headerName: "状态",
      field: 'stateStr',
      width: 15,
      cellStyle: {
        textAlign: 'left',
      },
      style: {
        alignment: { vertical: 'middle', horizontal: 'center' },
      },
    },
  ];
} 